export default __webpack_public_path__ + "static/media/telefone.59042869.svg";